import { configureStore } from '@reduxjs/toolkit';
import sessionReducer from './sessionSlice';
import playerReducer from './playerSlice';

const STORAGE_KEY = 'cyberdeck.session';

const loadState = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? { session: JSON.parse(raw) } : undefined;
  } catch {
    return undefined;
  }
};

const store = configureStore({
  reducer: { session: sessionReducer, player: playerReducer },
  preloadedState: loadState()
});

store.subscribe(() => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store.getState().session));
  } catch {
    // ignore write failures (e.g. storage disabled)
  }
});

export default store;
